module.exports = __webpack_public_path__ + "static/media/brokenLink.a95872cb.png";